<template>
    <!-- Кубик, як у «Випадковій піці» (стилі .bp-dice* у v2.css): падає згори, перекидається й лягає гранню value
         до глядача (land="front") або догори (land="top"). Новий кидок — зміна roll -->
    <div class="bp-dice" :key="roll" :style="{ '--rx': rx + 'deg', '--ry': ry + 'deg' }" aria-hidden="true">
        <span class="bp-dice__shadow"></span>
        <div class="bp-dice__toss"><div class="bp-dice__tilt"><div class="bp-dice__cube">
            <span v-for="face in faces" :key="face.n" :class="'bp-dice__f bp-dice__f--' + face.n">
                <img v-if="logo && face.n == 1" :src="logoSrc" alt="" class="bp-dice__logo">
                <i v-else v-for="cell in face.pips" :key="cell" :style="{ gridRow: Math.ceil(cell / 3), gridColumn: (cell - 1) % 3 + 1 }"></i>
            </span>
        </div></div></div>
    </div>
</template>

<script>
// Грані: клітинки 3×3 з крапками і поворот куба, що ставить грань до глядача
const FACES = [
    { n: 1, pips: [5], rx: 0, ry: 0 },
    { n: 2, pips: [1, 9], rx: -90, ry: 0 },
    { n: 3, pips: [1, 5, 9], rx: 0, ry: -90 },
    { n: 4, pips: [1, 3, 7, 9], rx: 0, ry: 90 },
    { n: 5, pips: [1, 3, 5, 7, 9], rx: 90, ry: 0 },
    { n: 6, pips: [1, 3, 4, 6, 7, 9], rx: 0, ry: 180 }
];

export default {
    name: 'BpDice',
    props: {
        value: { type: Number, default: 1 },
        roll: { type: Number, default: 0 },
        land: { type: String, default: 'front' },
        logo: { type: Boolean, default: false }
    },
    data() {
        return {
            faces: FACES,
            logoSrc: require('@/assets/logo_site_mob.webp')
        }
    },
    computed: {
        // Два повні оберти по кожній осі, напрям — від номера кидка; «догори» — ще +90° по X
        rx() {
            const face = FACES[this.value - 1] || FACES[0];
            return (this.roll % 2 ? -720 : 720) + face.rx + (this.land == 'top' ? 90 : 0);
        },
        ry() {
            const face = FACES[this.value - 1] || FACES[0];
            return (this.roll % 3 ? 720 : -720) + face.ry;
        }
    }
}
</script>
